import { TASK_TYPE } from '@/views/feed/constants/defaults'
import MasterTaskMock from '@/../test/mocks/endpoints/feed/master-task-mock'
const DEBUG_TASKS_DONE = false

let mockPollingGutenbergReachoutCounter = 0

const buildMasterTasksUrl = (configs, { offset, limit, search, filterBy, searchParams, onlyReplyToMember }, path = '') => {
  const url = `/therapist/v${configs.api.version}/feed/tasks${path}`
  const queryParams = new URLSearchParams(searchParams)

  queryParams.append(onlyReplyToMember ? 'only_types' : 'not_only_types', [TASK_TYPE.PENDING_REPLY, TASK_TYPE.REACH_OUT])

  if (offset !== undefined) queryParams.append('offset', offset)
  if (limit) queryParams.append('limit', limit)
  if (queryParams.has('filters', '')) queryParams.delete('filters')

  if (search) {
    queryParams.append('search', search)
    queryParams.append('search_type', filterBy)
  }

  return `${url}?${queryParams}`
}

export default {
  fetchMasterTasksList: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'get',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      forceMock: DEBUG_TASKS_DONE,
      mock: (_, userId) => {
        console.log('Getting mock UML master tasks for user with Id: ', userId)

        return 'mocks/endpoints/unified-members-list/fetchMasterTasksList.json'
      },
    },
    $$makeUrl: (configs, params) => buildMasterTasksUrl(configs, params),
  },
  fetchMasterTasksListCount: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'get',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl: (configs, params) => buildMasterTasksUrl(configs, params, '/count'),
  },
  fetchMasterTask: {
    api: {
      url: 'default',
      version: 2,
    },
    $$method: 'get',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      forceMock: false,
      mock: () => MasterTaskMock(
        [
          'session_done',
          // 'pending_prescription',
          // 'pending_prescription_v2',
          // 'gutenberg_reachout',
          // 'upcoming_call',
          // 'protocol_progression',
          // 'protocol_progression:bloom',
          // 'pending_resistance_prescription',
          // 'plan_of_care',
          // 'pending_reply',
          // 'pending_exclusion',
          // 'academy_suggestion',
          // 'problematic_reassessment',
          // 'follow_up_prescription',
          // 'referral_rejection',
        ],
        [
          // 'problematic_session',
        ]),
    },
    $$makeUrl(configs, programUuid) {
      return `/therapist/v${configs.api.version}/feed/programs/${programUuid}/tasks`
    },
  },
  fetchFeedProgramSummary: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'get',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      forceMock: false,
      mock: () => {
        return 'mocks/endpoints/feed/fetchFeedProgramSummaryVM.json'
      },
    },
    $$makeUrl(configs, programUuid) {
      return `/therapist/v${configs.api.version}/feed/programs/${programUuid}/summary`
    },
  },
  fetchFeedProgramChart: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'get',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      forceMock: false,
      mock: () => {
        return 'mocks/endpoints/feed/fetchFeedProgramChartVM.json'
      },
    },
    $$makeUrl(configs, programUuid) {
      return `/therapist/v${configs.api.version}/feed/programs/${programUuid}/chart`
    },
  },
  fetchFeedProgramBanner: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'get',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      forceMock: false,
      mock: () => {
        return 'mocks/endpoints/feed/fetchFeedProgramBannerVM.json'
      },
    },
    $$makeUrl(configs, programUuid) {
      return `/therapist/v${configs.api.version}/feed/programs/${programUuid}/banner`
    },
  },
  fetchFeedProgramCalendar: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'get',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, { programUuid, accountUuid, memberTimezone, unit }) {
      const params = new URLSearchParams()

      params.append('account_uuid', accountUuid)
      params.append('member_timezone', memberTimezone)
      params.append('unit', unit)

      return `/therapist/v${configs.api.version}/feed/programs/${programUuid}/calendar?${params}`
    },
  },
  preFetchGutenbergReachOutInMasterTask: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'get',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      forceMock: false,
      mock: () => {
        return 'mocks/endpoints/unified-members-list/fetchMasterTask.json'
      },
    },
    $$makeUrl(configs, masterTaskId) {
      return `/therapist/v${configs.api.version}/ai-feed/master-task/${masterTaskId}/preload-gutenberg`
    },
  },
  shortPollingGutenbergReachOut: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'get',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      forceMock: false,
      mock: () => {
        mockPollingGutenbergReachoutCounter++
        if (mockPollingGutenbergReachoutCounter === 3) {
          return 'mocks/endpoints/feed/gutenbergReachoutPoolingFailed.json'
        }

        if (mockPollingGutenbergReachoutCounter >= 5) {
          return 'mocks/endpoints/feed/gutenbergReachoutPoolingCompleted.json'
        }

        return 'mocks/endpoints/feed/gutenbergReachoutPoolingPending.json'
      },
    },
    $$makeUrl(configs, taskUuid) {
      return `/therapist/v${configs.api.version}/gutenberg-reachouts/${taskUuid}/polling`
    },
  },
  snoozeMemberMasterTask: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'put',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, masterTaskId) {
      return `/therapist/v${configs.api.version}/uml/master-tasks/${masterTaskId}/status`
    },
  },
  flagSubTaskAsDismissed: {
    $$method: 'put',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      forceMock: DEBUG_TASKS_DONE,
      mock: () => 'mocks/endpoints/requestResponses/emptyHit.json',
    },
    $$makeUrl: (configs, url) => url,
  },
  flagSubTaskAsDismissedAsPost: {
    $$method: 'post',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      forceMock: DEBUG_TASKS_DONE,
      mock: () => 'mocks/endpoints/requestResponses/emptyHit.json',
    },
    $$makeUrl: (configs, url) => url,
  },
  applyExclusionRequestAction: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'post',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      forceMock: DEBUG_TASKS_DONE,
      mock: () => 'mocks/endpoints/requestResponses/emptyHit.json',
    },
    $$makeUrl: (configs, { subtaskUuid, actionKey }) => {
      return `therapist/v${configs.api.version}/exclusion-requests/${subtaskUuid}/status/${actionKey}`
    },
  },
  updatePendingPlanOfCareNote: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'put',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, pendingPlanOfCareUuid) {
      return `therapist/v${configs.api.version}/pending-plan-of-care-notes/${pendingPlanOfCareUuid}`
    },
  },
  bulkSuggestedActions: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'post',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs) {
      return `therapist/v${configs.api.version}/uml/taskinhas/bulk-suggested-actions`
    },
  },
  sendGutenbergReachOutAutoSuggestedMessage: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'post',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, reachOutUuid) {
      return `therapist/v${configs.api.version}/gutenberg-reachouts/${reachOutUuid}/complete`
    },
  },
  sendAcademySuggestion: {
    api: {
      url: 'default',
      version: '1',
    },
    $$method: 'put',
    $$config: {
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, subtaskUuid) {
      return `therapist/v${configs.api.version}/uml/taskinhas/${subtaskUuid}/messages/mark-as-done`
    },
  },
  sendClinicalReferralAction: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'post',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, { subtaskId, referralUuid }) {
      return `therapist/v${configs.api.version}/ai-feed/taskinhas/${subtaskId}/referrals/${referralUuid}`
    },
  },
  newsfeedList: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'get',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$meta: {
      forceMock: false,
      mock: () => 'mocks/endpoints/newsfeed/fetchNewsfeedList.json',
    },
    $$makeUrl(configs, { programUuid, status }) {
      return `therapist/v${configs.api.version}/ai-feed/newsfeed?status=${status}&program_uuid=${programUuid}`
    },
  },
  archiveNewsfeedItem: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'put',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, { newsfeedItemId }) {
      return `therapist/v${configs.api.version}/ai-feed/newsfeed/${newsfeedItemId}/archive`
    },
  },
  applyTaskSuggestion: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'patch',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, { programUuid, groupUuid, groupType, uiAction }) {
      return `therapist/v${configs.api.version}/feed/programs/${programUuid}/group/${groupType}/uuid/${groupUuid}/ui-action/${uiAction}`
    },
  },
  applyTaskBulkSuggestion: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'patch',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, { programUuid, collectionUuid, uiAction }) {
      return `therapist/v${configs.api.version}/feed/programs/${programUuid}/collection/${collectionUuid}/ui-action/${uiAction}`
    },
  },
  postponeTaskItem: {
    api: {
      url: 'default',
      version: 1,
    },
    $$method: 'put',
    $$config: {
      withCredentials: true,
      headers: (data) => data.headers.authorization,
    },
    $$makeUrl(configs, taskItemId) {
      return `therapist/v${configs.api.version}/feed/taskinhas/${taskItemId}/postpone`
    },
  },
}
